'use client'

import { getRelatedProducts, getSettingList } from '@/lib/api'
import { Common, dynamic } from '@/config/NextImport'
import { useEffect, useState } from 'react'
import { Autoplay, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { getQueryClient } from '@/lib/get-query-client'
import { usePathname } from 'next/navigation'

const YouMayAlsoLikeItem = dynamic(() => import('./YouMayAlsoLikeItem'))

type SettingListResponse = {
  pages: {
    products: any[]
  }[]
}
const YouMayAlsoLike = ({ productIds, category }: any) => {
  const queryClient = getQueryClient()
  const pathname = usePathname()
  const currentSku = pathname.split('-sku-').reverse()[0]
  const [relatedProducts, setRelatedProducts] = useState<any>([])

  useEffect(() => {
    if (productIds?.length === 0) {
      fetchRelatedProductsCategoryWise()
    }
  }, [])

  const fetchRelatedProductsCategoryWise = async () => {
    const payload = {
      // page_no: 0,
      page_size: Common.Pagesize,
      category_url: category.slug,
      filters: {},
      can_be_set_shape: '',
      can_be_set_carat: '',
      path_name: category.slug
    }
    const queryKey = ['settingList', category.slug]
    const existing = queryClient.getQueryData<SettingListResponse>(queryKey)
    if (existing?.pages?.[0]?.products) {
      const filtered = existing.pages[0].products.filter((item: any) => item.sku !== currentSku)
      setRelatedProducts(filtered.slice(0, 4))
    } else {
      try {
        const response = await getSettingList(payload)
        const data = response.result
        if (data != null) {
          data.data = data.data.filter((item: any) => item.sku !== currentSku)
          setRelatedProducts(data.data.slice(0, 4))
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  useEffect(() => {
    if (productIds && productIds?.length > 0) {
      fetchRelatedProducts()
    }
  }, [])
  const fetchRelatedProducts = async () => {
    const response = await getRelatedProducts(productIds)
    try {
      const data = response.result
      if (data != null) {
        setRelatedProducts(data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  if (relatedProducts.length === 0) return
  return (
    <>
      <div className="container-fluid">
        <div className="youmay-also-like-product">
          {' '}
          {/* product Listing section */}
          <h2 className="heading-title text-custom text-uppercase text-center">
            You May Also Like
          </h2>
          <div className="product-listing">
            <div className="row mx-0">
              <Swiper
                effect="fade"
                slidesPerView={4}
                modules={[Navigation, Autoplay]}
                navigation={true}
                loop={relatedProducts.length > 4}
                autoplay={false}
                speed={800}
                spaceBetween={20}
                breakpoints={{
                  300: {
                    slidesPerView: 2
                  },
                  768: {
                    slidesPerView: 2
                  },
                  991: {
                    slidesPerView: 3
                  },
                  1200: {
                    slidesPerView: 4
                  }
                }}
              >
                {relatedProducts?.map((item: any) => (
                  <SwiperSlide key={item._id}>
                    <YouMayAlsoLikeItem
                      item={item}
                      category={category}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default YouMayAlsoLike
